import { Item } from '@baemingo/inventory-events/dist/types';
import { InventoryState } from 'actions';

export const checkOutOfStock = (itemId: string, inventory: InventoryState) => {
  const inventoryForItem = inventory.find((invItem: Item) => invItem.itemId === itemId);
  return !!(inventoryForItem?.outOfStock || inventoryForItem?.count === 0);
};

export const checkVariationOutOfStock = (variationId: string, inventory: InventoryState) => {
  const inventoryForItem = inventory.find((invItem: Item) => invItem.itemId === variationId);
  return inventoryForItem ? inventoryForItem.outOfStock : false;
};
